import React from "react";
import { bool, string, func, oneOf } from "prop-types";
import { Col } from "../Grid";
import Button from "../Button";
import { classes } from "../utils/classes";
import Image from "../Image";

const TestimonialTabsItem = ({
	logoImg,
	isBaseUrl,
	active = false,
	grayscale = false,
	invert,
	onClick = () => {},
}) => {
	return (
		<Col md={4} lg="auto">
			<Button
				className={classes("testimonials-customers__tab ", active && "active")}
				styleType="link"
				onClick={onClick}
			>
				<Image src={logoImg} isBaseUrl={isBaseUrl} grayscale={grayscale} invert={invert} />
			</Button>
		</Col>
	);
};

TestimonialTabsItem.propTypes = {
	logoImg: string.isRequired,
	onClick: func,
	grayscale: bool,
	invert: oneOf(["white", "black"]),
	active: bool,
	isBaseUrl: bool,
};

export default TestimonialTabsItem;
